// extracted by mini-css-extract-plugin
module.exports = {"pdpV2ConfigurableSkuBadge":"az_wxc","configurableSkuBadge":"az_xxc","text":"az_yxc"};